module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-precomposed-d322e7397e88b16247bff6f8d9e037d3.png";